var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000111171981808509338120000006902543350436785304_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#CF142B;}\n\t.st3{fill:#00247D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 8,
    cy: 8,
    r: 8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000126312916444230255480000009780415859168171428_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000126312916444230255480000009780415859168171428_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "c",
    x: -8,
    className: "st1",
    width: 32,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "d",
    className: "st2",
    points: "6.4,9.6 6.4,16 9.6,16 9.6,9.6 24,9.6 24,6.4 9.6,6.4 9.6,0 6.4,0 6.4,6.4 -8,6.4 -8,9.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e",
    className: "st3",
    points: "10.7,5.2 10.7,0 21,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "f",
    className: "st3",
    points: "10.7,10.8 10.7,16 21,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "g",
    className: "st3",
    points: "5.3,10.8 5.3,16 -5,16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "h",
    className: "st3",
    points: "5.3,5.2 5.3,0 -5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "i",
    className: "st3",
    points: "-8,1.5 -8,5.3 -0.3,5.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "j",
    className: "st3",
    points: "24,1.5 24,5.3 16.3,5.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "k",
    className: "st3",
    points: "24,14.5 24,10.7 16.3,10.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "l",
    className: "st3",
    points: "-8,14.5 -8,10.7 -0.3,10.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "m",
    className: "st2",
    points: "24,0 22.2,0 11.6,5.3 13.3,5.3 24,0  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "n",
    className: "st2",
    points: "4.4,10.7 2.6,10.7 -8,16 -6.2,16 4.4,10.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "o",
    className: "st2",
    points: "0.9,5.3 2.7,5.3 -8,0 -8,0.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "p",
    className: "st2",
    points: "15.1,10.7 13.3,10.7 24,16 24,15.1  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkRound);
export default __webpack_public_path__ + "static/media/uk-round.b36707736b985e8ce9d14ee5b91346a7.svg";
export { ForwardRef as ReactComponent };